import { getUserSnippetPipeline } from "../users/user-snippet-resource";

export function getTaskPipelines() {
  const taskUserPipeline = getUserSnippetPipeline("userId", "userDoc");

  return {
    mainStages: [...taskUserPipeline.mainStages],
    projectStage: {
      _id: 1,
      title: 1,
      description: 1,
      dueAt: 1,
      completionInfo: 1,
      subTasks: 1,
      ...taskUserPipeline.projectStage,
    },
  };
}
